import React from 'react';
import {
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList, IonMenu, IonMenuToggle,
} from "@ionic/react";
import {
  exit,
  briefcase,
  home,
  medkit,
  fileTrayStacked,
  calendar,
  peopleCircleOutline,
  settingsSharp,
  swapHorizontalOutline,
} from "ionicons/icons";
import {version} from "../config";
import classNames from "classnames";

import styles from './Menu.module.css';

interface MenuProps {
  onClickExit: () => void;
  onClick: (key:string) => void;
  user: any;
}

export const Menu:React.FC<MenuProps> = ({onClickExit, onClick, user}) => {
  return (
    <IonMenu contentId="main" type="overlay" className={styles.menu}>
      <IonContent className={styles.menu}>
        <div className="flex justify-center w-full h-32 mt-4">
          <div className={classNames("w-full px-4 py-2", styles.icone)}/>
        </div>
        <IonList className={classNames(styles.menuList, "py-0 my-6")}>
          {
            user.hasProfile && user.profileComplete &&
              <>
                <MenuItem path="home" icon={home} onClick={onClick} label="Home"/>
                <MenuItem path="agenda" icon={calendar} onClick={onClick} label="Próximos contatos"/>
                <MenuItem path="lojas" icon={briefcase} onClick={onClick} label="Revendas e Cooperativas"/>
                <MenuItem path="veterinarios" icon={medkit} onClick={onClick} label="Veterinários"/>
                <MenuItem path="proprietarios" icon={peopleCircleOutline} onClick={onClick} label="Proprietários"/>
                <MenuItem path="fazendas" icon={fileTrayStacked} onClick={onClick} label="Fazendas"/>
                <MenuItem path="eventos" icon={calendar} onClick={onClick} label="Histórico"/>
                <MenuItem path="cadastro" icon={settingsSharp} onClick={onClick} label="Cadastro"/>
                <MenuItem path="transferencias" icon={swapHorizontalOutline} onClick={onClick} label="Transferências"/>
              </>
          }

          <IonMenuToggle auto-hide="false">
            <IonItem button={true} onClick={onClickExit} color="tertiary">
              <IonIcon icon={exit} slot="start"/>
              <IonLabel>Sair</IonLabel>
            </IonItem>
          </IonMenuToggle>
        </IonList>

        <div className="mt-2 text-right text-gray-400 text-xs pr-4">
          versão: {version}
        </div>
      </IonContent>
    </IonMenu>
  )
};

interface MenuItemProps {
  path: string;
  icon: any;
  onClick: (key:string) => void;
  label: string;
}

const MenuItem:React.FC<MenuItemProps> = ({path, icon, label, onClick}) => (
  <IonMenuToggle auto-hide="false">
    <IonItem button={true} onClick={() => onClick(path)} color="tertiary">
      <IonIcon icon={icon} slot="start"/>
      <IonLabel>{label}</IonLabel>
    </IonItem>
  </IonMenuToggle>
);
